export const loadPlausible = () => {
  const $document = angular.injector(['ng']).get('$document')[0];
  const env = {};
  env.isDev = location.hostname.includes('.dev.');
  env.isTest = location.hostname.includes('.test.');
  env.isLocal =
    location.hostname.indexOf('localhost') > -1 ||
    !/[a-z]/i.test(location.hostname);
  env.prefix = env.isDev || env.isLocal ? 'dev.' : env.isTest ? 'test.' : '';

  const url = 'https://plsbl.' + env.prefix + 'fino.cloud/js/script.js';
  const el = $document.getElementsByTagName('script')[0];
  const script = $document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.defer = true;
  // Remove subsubdomain from domain
  // eslint-disable-next-line
  script.dataset.domain = location.hostname.replace(/^[^\.]*\./, '');
  script.src = `${url}`;

  el.parentNode.insertBefore(script, el);
};
